/**
 * Personalizador de Carta — Shopify
 * Archivo: assets/personalizador-carta.js
 *
 * Funcionalidades:
 *  - Abrir / cerrar el modal
 *  - Vista previa en tiempo real (formato: Para / Lugar / Calle / Colonia / Ciudad, País)
 *  - Validación de campos
 *  - Habilitar/deshabilitar el botón de agregar al carrito
 *  - Envío al carrito de Shopify vía AJAX (funciona con carrito vacío)
 */

(function () {
  'use strict';

  /* ── Selectores ── */
  const modal    = document.getElementById('PersonalizadorModal');
  const overlay  = document.getElementById('PersonalizadorOverlay');
  const btnAbrir = document.getElementById('PersonalizadorAbrir');
  const btnCerrar= document.getElementById('PersonalizadorCerrar');
  const form     = document.getElementById('PersonalizadorForm');
  const btnEnviar= document.getElementById('PersonalizadorSubmit');

  /* Campos del formulario */
  const campos = {
    tratamiento: document.getElementById('campo-titulo'),
    nombre:      document.getElementById('campo-nombre'),
    apellido:    document.getElementById('campo-apellido'),
    lugar:       document.getElementById('campo-lugar'),
    calle:       document.getElementById('campo-calle'),
    colonia:     document.getElementById('campo-colonia'),
    ciudad:      document.getElementById('campo-ciudad'),
    pais:        document.getElementById('campo-pais'),
  };

  /* Elementos de vista previa */
  const previewIds = {
    sobre: {
      tratamiento: document.getElementById('preview-tratamiento-sobre'),
      nombre:      document.getElementById('preview-nombre-sobre'),
      apellido:    document.getElementById('preview-apellido-sobre'),
      lugar:       document.getElementById('preview-lugar-sobre'),
      calle:       document.getElementById('preview-calle-sobre'),
      colonia:     document.getElementById('preview-colonia-sobre'),
      ciudad:      document.getElementById('preview-ciudad-sobre'),
      pais:        document.getElementById('preview-pais-sobre'),
      paisSep:     document.getElementById('preview-pais-sobre-sep'),
    },
    carta: {
      tratamiento: document.getElementById('preview-tratamiento-carta'),
      nombre:      document.getElementById('preview-nombre-carta'),
      apellido:    document.getElementById('preview-apellido-carta'),
      lugar:       document.getElementById('preview-lugar-carta'),
      calle:       document.getElementById('preview-calle-carta'),
      colonia:     document.getElementById('preview-colonia-carta'),
      ciudad:      document.getElementById('preview-ciudad-carta'),
      pais:        document.getElementById('preview-pais-carta'),
      paisSep:     document.getElementById('preview-pais-carta-sep'),
    },
    saludo: {
      tratamiento: document.getElementById('preview-tratamiento-saludo'),
      nombre:      document.getElementById('preview-nombre-saludo'),
      apellido:    document.getElementById('preview-apellido-saludo'),
    },
  };

  /* ── Validaciones ── */
  const reglas = {
    tratamiento: { requerido: true },
    nombre:      { requerido: true, patron: /^[a-záéíóúüñA-ZÁÉÍÓÚÜÑ\s'-]+$/i },
    apellido:    { requerido: true, patron: /^[a-záéíóúüñA-ZÁÉÍÓÚÜÑ\s'-]+$/i },
    lugar:       { requerido: true },
    calle:       { requerido: true },
    colonia:     { requerido: true },
    ciudad:      { requerido: true },
    pais:        { requerido: true },
  };

  function valorCampo(nombre) {
    const campo = campos[nombre];
    if (!campo) return '';
    if (campo.tagName === 'SELECT') {
      return campo.options[campo.selectedIndex]?.value ?? '';
    }
    return campo.value ?? '';
  }

  function validarCampo(nombre, valor) {
    const regla = reglas[nombre];
    if (!regla) return true;
    if (regla.requerido && !valor.trim()) return false;
    if (valor.trim() && regla.patron && !regla.patron.test(valor.trim())) return false;
    return true;
  }

  function formularioValido() {
    return Object.keys(reglas).every((nombre) => {
      return validarCampo(nombre, valorCampo(nombre));
    });
  }

  /* ── Vista previa en tiempo real ── */
  function actualizarPreview() {
    const v = {
      tratamiento: valorCampo('tratamiento'),
      nombre:      valorCampo('nombre').trim(),
      apellido:    valorCampo('apellido').trim(),
      lugar:       valorCampo('lugar').trim(),
      calle:       valorCampo('calle').trim(),
      colonia:     valorCampo('colonia').trim(),
      ciudad:      valorCampo('ciudad').trim(),
      pais:        valorCampo('pais').trim(),
    };

    // Separador ", " entre ciudad y país, solo si ambos tienen valor
    const sep = (v.ciudad && v.pais) ? ', ' : '';

    /* Sobre */
    setText(previewIds.sobre.tratamiento, v.tratamiento);
    setText(previewIds.sobre.nombre,      v.nombre);
    setText(previewIds.sobre.apellido,    v.apellido);
    setText(previewIds.sobre.lugar,       v.lugar);
    setText(previewIds.sobre.calle,       v.calle);
    setText(previewIds.sobre.colonia,     v.colonia);
    setText(previewIds.sobre.ciudad,      v.ciudad);
    setText(previewIds.sobre.paisSep,     sep);
    setText(previewIds.sobre.pais,        v.pais ? `${v.pais}.` : '');

    /* Carta */
    setText(previewIds.carta.tratamiento, v.tratamiento);
    setText(previewIds.carta.nombre,      v.nombre);
    setText(previewIds.carta.apellido,    v.apellido);
    setText(previewIds.carta.lugar,       v.lugar);
    setText(previewIds.carta.calle,       v.calle);
    setText(previewIds.carta.colonia,     v.colonia);
    setText(previewIds.carta.ciudad,      v.ciudad);
    setText(previewIds.carta.paisSep,     sep);
    setText(previewIds.carta.pais,        v.pais ? `${v.pais}.` : '');

    /* Saludo: Querido/a Srita. Carrasco: */
    setText(previewIds.saludo.tratamiento, v.tratamiento);
    setText(previewIds.saludo.nombre,      v.nombre);
    setText(previewIds.saludo.apellido,    v.apellido);

    /* Habilitar/deshabilitar botón */
    btnEnviar.disabled = !formularioValido();
  }

  function setText(el, texto) {
    if (el) el.textContent = texto;
  }

  /* ── Modal: abrir / cerrar ── */
  function abrirModal() {
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    modal.focus();
  }

  function cerrarModal() {
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    btnAbrir?.focus();
  }

  /* ── Detectar el section ID del header en el DOM ──
   * El tema Savor usa IDs como "sections--XXXXX__header_section".
   * Lo buscamos dinámicamente para no hardcodear el ID.
   */
  function detectarSeccionesDelTema() {
    const secciones = [];
    document.querySelectorAll('[data-section-id]').forEach((el) => {
      const id = el.getAttribute('data-section-id');
      if (id) secciones.push(id);
    });
    // Si no encontró nada con data-section-id, buscar por id de elemento con shopify-section
    if (secciones.length === 0) {
      document.querySelectorAll('[id^="shopify-section-"]').forEach((el) => {
        secciones.push(el.id.replace('shopify-section-', ''));
      });
    }
    return secciones;
  }

  /* ── Envío al carrito vía AJAX (patrón exacto del tema Savor) ──
   *
   * El tema Savor envía FormData con las secciones incluidas como campo "sections".
   * Shopify devuelve la respuesta con un campo "sections" que contiene el HTML
   * actualizado de cada sección. Luego se actualizan los elementos del DOM
   * buscando por el prefijo "shopify-section-{id}".
   */
  async function agregarAlCarrito(e) {
    e.preventDefault();

    if (!formularioValido()) return;

    const spinner = btnEnviar.querySelector('.personalizador__spinner');
    const texto   = btnEnviar.querySelector('span:not(.personalizador__spinner)');

    btnEnviar.disabled = true;
    if (spinner) spinner.removeAttribute('hidden');
    if (texto)   texto.textContent = 'Agregando…';

    try {
      const variantId = form.querySelector('input[name="id"]')?.value;
      if (!variantId) throw new Error('No se encontró el ID de variante del producto.');

      // Construir FormData igual que lo hace el tema
      const formData = new FormData(form);

      // Agregar las secciones detectadas dinámicamente para que Shopify
      // devuelva su HTML actualizado junto con la respuesta
      const seccionesDetectadas = detectarSeccionesDelTema();
      if (seccionesDetectadas.length > 0) {
        formData.append('sections', seccionesDetectadas.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      const respuesta = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { Accept: 'application/javascript' },
        body:    formData,
      });

      if (!respuesta.ok) {
        let mensajeError = `Error ${respuesta.status}`;
        try {
          const errJson = await respuesta.json();
          mensajeError = errJson.description ?? errJson.message ?? mensajeError;
        } catch (_) { /* ignorar */ }
        throw new Error(mensajeError);
      }

      const datos = await respuesta.json();

      // Éxito: actualizar secciones con el HTML que devolvió Shopify
      if (datos.sections) {
        aplicarSecciones(datos.sections);
      } else {
        // Si no vino con secciones, pedirlas por separado
        await pedirYAplicarSecciones(seccionesDetectadas);
      }

      cerrarModal();
      mostrarNotificacion('¡Producto agregado al carrito!');

    } catch (err) {
      console.error('[Personalizador] Error al agregar al carrito:', err);
      mostrarNotificacion('Ocurrió un error. Por favor inténtalo de nuevo.', 'error');
    } finally {
      if (spinner) spinner.setAttribute('hidden', '');
      if (texto)   texto.textContent = 'Agregar al carrito';
      btnEnviar.disabled = false;
    }
  }

  /* ── Aplicar HTML de secciones al DOM ──
   * Savor busca elementos con id "shopify-section-{sectionId}"
   * y reemplaza su contenido con el HTML recibido.
   */
  function aplicarSecciones(secciones) {
    Object.entries(secciones).forEach(([sectionId, html]) => {
      if (!html) return;

      // El tema Savor usa el prefijo "shopify-section-"
      const elDestino = document.getElementById(`shopify-section-${sectionId}`)
        ?? document.querySelector(`[data-section-id="${sectionId}"]`);

      if (!elDestino) return;

      const parser  = new DOMParser();
      const docNuevo = parser.parseFromString(html, 'text/html');

      // Buscar el nodo raíz equivalente en el HTML devuelto
      const elNuevo = docNuevo.getElementById(`shopify-section-${sectionId}`)
        ?? docNuevo.querySelector(`[data-section-id="${sectionId}"]`)
        ?? docNuevo.body.firstElementChild;

      if (elNuevo) {
        elDestino.innerHTML = elNuevo.innerHTML;
      }
    });
  }

  /* ── Pedir secciones actualizadas por separado (fallback) ── */
  async function pedirYAplicarSecciones(secciones) {
    if (!secciones || secciones.length === 0) {
      // Sin secciones conocidas: recargar como último recurso
      window.location.reload();
      return;
    }
    try {
      const res  = await fetch(`/cart?sections=${secciones.join(',')}`);
      const data = await res.json();
      aplicarSecciones(data);
    } catch (_) {
      window.location.reload();
    }
  }

  /* ── Notificación simple ── */
  function mostrarNotificacion(mensaje, tipo = 'exito') {
    const notif = document.createElement('div');
    notif.className = `personalizador__notif personalizador__notif--${tipo}`;
    notif.setAttribute('role', 'alert');
    notif.textContent = mensaje;

    Object.assign(notif.style, {
      position:     'fixed',
      bottom:       '1.5rem',
      left:         '50%',
      transform:    'translateX(-50%)',
      background:   tipo === 'exito' ? '#2e7d32' : '#c62828',
      color:        '#fff',
      padding:      '0.75rem 1.5rem',
      borderRadius: '8px',
      fontWeight:   '600',
      zIndex:       '2000',
      boxShadow:    '0 4px 16px rgba(0,0,0,0.18)',
      transition:   'opacity 0.3s',
    });

    document.body.appendChild(notif);

    setTimeout(() => {
      notif.style.opacity = '0';
      setTimeout(() => notif.remove(), 320);
    }, 3000);
  }

  /* ── Accesibilidad: cerrar con Escape ── */
  function manejarTeclado(e) {
    if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
      cerrarModal();
    }
  }

  /* ── Mostrar errores de validación al perder el foco ── */
  function manejarBlur(e) {
    const campo = e.target;
    const nombre = Object.keys(campos).find((k) => campos[k] === campo);
    if (!nombre) return;

    const valor = valorCampo(nombre);
    const valido = validarCampo(nombre, valor);

    campo.classList.toggle('error', !valido && valor.length > 0);

    let msgEl = campo.parentElement.querySelector('.personalizador__input-error-msg');
    if (!valido && valor.length > 0) {
      if (!msgEl) {
        msgEl = document.createElement('span');
        msgEl.className = 'personalizador__input-error-msg';
        msgEl.setAttribute('aria-live', 'polite');
        campo.parentElement.appendChild(msgEl);
      }
      msgEl.textContent = campo.dataset.error ?? 'Campo inválido.';
    } else if (msgEl) {
      msgEl.remove();
      campo.classList.remove('error');
    }
  }

  /* ── Inicialización ── */
  function init() {
    if (!modal) return;

    // Mover el modal a ser hijo directo de <body>. Esto evita que quede
    // "atrapado" dentro de algún ancestro con transform / position: sticky
    // (común en columnas de producto con contenido sticky), lo cual rompe
    // position: fixed y hace que el modal no cubra toda la pantalla.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    btnAbrir?.addEventListener('click', abrirModal);
    btnCerrar?.addEventListener('click', cerrarModal);
    overlay?.addEventListener('click', cerrarModal);
    document.addEventListener('keydown', manejarTeclado);

    form?.addEventListener('submit', agregarAlCarrito);

    Object.values(campos).forEach((campo) => {
      if (!campo) return;
      campo.addEventListener('input', actualizarPreview);
      campo.addEventListener('change', actualizarPreview);
      campo.addEventListener('blur', manejarBlur);
    });

    actualizarPreview();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
